import { queryKeys } from '@/react-query/constants';
import { createFeatureApi } from '@/shared/api';

/** The users feature roots on queryKeys.teamMembers (TeamTable list + user CRUD invalidation).
 *  User-detail reads use queryKeys.user; level/permission reads use queryKeys.levels/permissions
 *  (their existing keys). INTERNAL — consumers use the exported hooks. */
export const usersApi = createFeatureApi(queryKeys.teamMembers);
